import { render, staticRenderFns } from "./PanelInvoiceTableRow.vue?vue&type=template&id=fbffda9c&scoped=true&"
import script from "./PanelInvoiceTableRow.vue?vue&type=script&lang=ts&"
export * from "./PanelInvoiceTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbffda9c",
  null
  
)

export default component.exports